export type Rgb = [number, number, number]

export function hexToRgb(hex: string): Rgb {
  const clean = hex.replace('#', '')
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean
  const int = Number.parseInt(full, 16)
  if (Number.isNaN(int)) return [242, 201, 76]
  return [(int >> 16) & 255, (int >> 8) & 255, int & 255]
}

export function rgbToHex([r, g, b]: Rgb): string {
  return `#${[r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('')}`
}

/** Tailwind consumes colours as space-separated channels so /opacity still works. */
export function channels(hex: string): string {
  return hexToRgb(hex).join(' ')
}

function mix(hex: string, target: Rgb, amount: number): string {
  const [r, g, b] = hexToRgb(hex)
  const blend = (a: number, t: number) => a + (t - a) * amount
  return channels(rgbToHex([blend(r, target[0]), blend(g, target[1]), blend(b, target[2])]))
}

export function softChannels(hex: string): string {
  return mix(hex, [255, 255, 255], 0.38)
}

export function deepChannels(hex: string): string {
  return mix(hex, [0, 0, 0], 0.32)
}
